import { reskinStyles } from 'core/components/theme/theme-variant';
import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  dialog: {
    width: 480,
    '@media (max-width: 480px)': {
      margin: theme.spacing(4),
      maxWidth: `calc(100% - ${theme.spacing(8)}px)`,
      '& > :last-child': { padding: theme.spacing(10, 5, 6) }
    },
    // BaseDialog's DialogContent (no title here). Mui* class names get numeric suffixes under a nested ThemeProvider.
    '& > :last-child': { overscrollBehavior: 'contain' }
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center'
  },
  title: {
    justifyContent: 'center',
    fontSize: 28,
    ...reskinStyles(theme, theme.modalTitle)
  },
  message: {
    justifyContent: 'center',
    marginTop: theme.spacing(6)
  },
  error: {
    justifyContent: 'center',
    marginTop: theme.spacing(4),
    color: theme.colors.error
  },
  appearanceOptions: {
    border: 0,
    padding: 0,
    margin: `${theme.spacing(6)}px 0 0`,
    width: '100%',
    minWidth: 0,
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  },
  legend: {
    color: theme.colors.text_primary,
    fontWeight: 600,
    marginBottom: theme.spacing(2)
  },
  customHint: { marginTop: theme.spacing(2), fontSize: 14, display: 'block' },
  confirmButton: {
    minWidth: 'min(255px, 100%)',
    marginTop: theme.spacing(10),
    marginBottom: theme.spacing(4)
  }
}));
